import { TStorageValTypes, IStorageEntity, TStorage } from './interface';
import Cookies from "js-cookie";

export const getStorageEntity = (key: string, storage: TStorage = 'localStorage'): IStorageEntity => ({

	get [key]() {
		if (storage === 'cookie') return Cookies.get(key);

		return window[storage][key];
	},

	set [key](v: TStorageValTypes) {
		if (storage === 'cookie') {
			Cookies.set(key, v as string, { path: '/' });

			return;
		}

		window[storage][key] = v;
	}

});